/** @jsx jsx */
import React, { type ReactNode } from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { RecaptchaTermsAndPolicy } from '@atlassian/google-recaptcha';
import { SuccessAutoDismissFlag } from '@atlassian/jira-flags';
import { useIntl, FormattedMessage } from '@atlassian/jira-intl';
import { messages } from './messages';

type AssigneeInvitedFlagProps = {
	id: string;
	email: string;
	onCancel: () => void;
	onDismissed: () => void;
};

export const AssigneeInvitedFlag = ({
	email,
	onCancel,
	onDismissed,
	...props
}: AssigneeInvitedFlagProps) => {
	const { formatMessage } = useIntl();

	return (
		<SuccessAutoDismissFlag
			title={formatMessage(messages.title)}
			description={
				<>
					<FormattedMessage
						{...messages.description}
						values={{
							email,
							strong: (chunks: ReactNode[]) => <strong>{chunks}</strong>,
						}}
					/>
					<div css={styles}>
						<RecaptchaTermsAndPolicy />
					</div>
				</>
			}
			onDismissed={onDismissed}
			actions={[
				{
					content: formatMessage(messages.actionCancel),
					onClick: onCancel,
				},
			]}
			{...props}
		/>
	);
};
const styles = css({
	font: token('font.body.small'),
	marginTop: token('space.100', '8px'),
});
